<div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form">

    <div *ngFor="let formField of formFields" class="form-group">
      <app-dynamic-form-creator [component]="componentInstance"  [input]="formField" [form]="form"></app-dynamic-form-creator>
    </div>

    <!--
    <div class="form-group">
      <button type="submit" class="btn btn-primary">Save & Send Report</button>
    </div>
-->

  </form>

  <div *ngIf="payLoad" class="form-group">
    <!--<strong>Here are the saved results (For debugging)</strong><br>{{payLoad}}-->
  </div>
</div>
